import { BaseComponent } from '../../components/base-component'
import { isMobile } from '../../utils/check-media'
import type { TabsComponent } from '../../components/tabs/tabs'
import { CarouselComponent } from 'src/scripts/components/carousel'
import { $el, whenDefined } from 'src/scripts/utils/utils'

const TABS_COMPONENT_SELECTOR = 'tabs-component'
const CAROUSEL_SELECTOR = 'carousel-component'

export class ProductDetails extends BaseComponent {
  isMobile: boolean = isMobile()
  resizeObserver: ResizeObserver

  mountComponent(): void {
    const tabs: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)
    whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
      tabs?.on('selectTab', this.handleTabSelect)
    })
  }

  unmountComponent(): void {
    const tabs: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)

    whenDefined(TABS_COMPONENT_SELECTOR).then(() => {
      tabs?.off('selectTab', this.handleTabSelect)
    })
    this.resizeObserver.disconnect()
  }

  handleTabSelect = (): void => {
    this.scrollToActiveTab()
  }

  handleResize = (): void => {
    if (isMobile() !== this.isMobile) {
      this.isMobile = isMobile()
    }

    if (isMobile()) {
      this.scrollToActiveTab()
    }
  }

  scrollToActiveTab = (): void => {
    const tabComponents: TabsComponent = $el(TABS_COMPONENT_SELECTOR, this)
    const carousel: CarouselComponent = $el(CAROUSEL_SELECTOR, this)

    if (!tabComponents || !carousel) {
      return
    }

    const activeTab = tabComponents
      .getNames()
      .findIndex(tab => tab.dataset.id === tabComponents.dataset.selectedTabId)

    carousel?.embla.scrollTo(activeTab)
  }
}
